import * as React from 'react';
import { Button } from 'reactstrap';

class TableBody extends React.Component {
    public render() {
        return (
            <tbody className="tableBody">
                {this.props.children}
            </tbody>
        );
    }
}

export default TableBody;